(() => {
  const init=root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const form=root.querySelector('form[action*="/cart/add"]');
    if(!form)return;
    const photo=root.querySelector('.hm-pdp-main img');
    const quantity=form.querySelector('[name="quantity"]');
    const changeImage=src=>{if(photo&&src){photo.src=src;photo.removeAttribute('srcset');}};
    const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:root.dataset.currency||'AED'}).format(value/100);
    root.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>changeImage(button.dataset.gallerySrc)));
    form.querySelectorAll('[name="happy-variant"]').forEach(radio=>radio.addEventListener('change',()=>{
      if(!radio.checked)return;
      form.querySelector('[data-variant-id]').value=radio.value;
      const submit=form.querySelector('[name="add"]');
      submit.disabled=radio.disabled;
      submit.textContent=submit.dataset.addLabel+' ↗';
      const price=Number(radio.dataset.price),original=Number(radio.dataset.compare)||price;
      root.querySelector('[data-product-price]').textContent=money(price);
      const compare=root.querySelector('[data-product-compare]'),saving=root.querySelector('[data-product-saving]');
      compare.hidden=saving.hidden=original<=price;compare.textContent=money(original);saving.textContent=saving.dataset.label+' '+money(Math.max(0,original-price));
      changeImage(radio.dataset.image);
      const url=new URL(window.location.href);url.searchParams.set('variant',radio.value);history.replaceState({},'',url);
    }));
    const clamp=()=>{quantity.value=Math.max(1,Math.min(99,Math.floor(Number(quantity.value)||1)));form.querySelector('[data-product-minus]').disabled=Number(quantity.value)<=1;};
    form.querySelector('[data-product-minus]').addEventListener('click',()=>{quantity.value=Number(quantity.value)-1;clamp();});
    form.querySelector('[data-product-plus]').addEventListener('click',()=>{quantity.value=Number(quantity.value)+1;clamp();});
    quantity.addEventListener('change',clamp);clamp();
  };
  document.querySelectorAll('[data-happy-product]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-happy-product]').forEach(init));
})();

